import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { normalizeCategorySlug } from 'modules/test/public-categories';
import TestsCatalog from './TestsCatalog';
import { IeltsPanel } from './ielts/IeltsPanel';

/** The tests page; the IELTS category adds the learner's band trend and weak topics under its tests. */
export default function TestsCatalogRoute() {
  const [params] = useSearchParams();
  const isIelts = normalizeCategorySlug(params.get('category')) === 'ielts';
  return (
    <>
      <TestsCatalog />
      {isIelts && <IeltsPanel />}
    </>
  );
}
